import React from 'react';
import { TargetIcon, ClipboardListIcon, LayersIcon, RefreshCwIcon, FolderOpenIcon, TimerIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: TargetIcon,
  color: 'text-brand'
}, {
  Icon: ClipboardListIcon,
  color: 'text-goldDark'
}, {
  Icon: LayersIcon,
  color: 'text-check'
}, {
  Icon: RefreshCwIcon,
  color: 'text-brand'
}, {
  Icon: FolderOpenIcon,
  color: 'text-goldDark'
}, {
  Icon: TimerIcon,
  color: 'text-navy'
}];
export function BenefitsGrid() {
  return <section className="bg-pale px-4 py-6 text-center md:px-12 md:py-7" data-id="element-1" data-mp="ewsh1sdxjk5q">
      <h2 className="mx-auto max-w-[620px] font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[26px]" data-id="element-2" data-mp="9yh61ebwf3lx">
        This isn't another theory-heavy speech therapy ebook.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] font-heading text-[13px] font-bold uppercase leading-tight text-brand md:text-[16px]" data-id="element-3" data-mp="3w4vz7053bssf">
        It's an organized collection of practical activities and professional resources.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-4" data-mp="26pcu35og85nk">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i];
        return <article key={b.title} className="flex gap-2.5 rounded-md border border-line bg-white p-3" data-id="element-5" data-mp="1wukxo56lroud" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-6" data-mp="21t4lyc8o5cpw" />
              <div data-id="element-7" data-mp="2pigquzwyqyme">
                <h3 className="font-heading text-[14px] font-bold leading-tight text-navy md:text-[15px]" data-id="element-8" data-mp="2pfunzdl0p7ai">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-9" data-mp="2gh93hcvzji73">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
    </section>;
}